import RequestBodyStructured_vue_vue_type_script_setup_true_lang_default from "./RequestBodyStructured.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/request-block/components/RequestBodyStructured.vue
var RequestBodyStructured_default = RequestBodyStructured_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestBodyStructured_default as default };

//# sourceMappingURL=RequestBodyStructured.vue.js.map